// // 该文件负责所有的公共的组件的全局注册   Vue.use
import FormModule from "./formModule";
import DDialog from "./DDialog";
import GeneralModel from "./generalModel";
import TableModule from "./tableModule";
import ButtonList from "./ButtonList";
import Label from "./Label";
import Title from "./Title";

let commonComponents = [
  FormModule,
  Title,
  ButtonList,
  Label,
  GeneralModel,
  DDialog,
  TableModule,
];

commonComponents.install = function (Vue) {
  commonComponents.forEach((item) => {
    Vue.component(item.name, item);
  });
};

export default commonComponents;
